import React from 'react';
import './DialogStyles.css';

interface DialogProps {
  isOpen: boolean;
  onClose: () => void;
  theCorrectSolution:string
  
  status?: 'success' | 'failure'
}

const SuccessDialog: React.FC<DialogProps> = ({
  isOpen,
  onClose,  
  status,
  theCorrectSolution
}) => {
  if (!isOpen) return null;
  return (
    <div className="success-failure-overlay">
      {status === 'success' ? (
        <div className="dialog success">
          <div className="dialog-icon">🎉</div>
          <div className="dialog-message">Congratulations! You've solved the puzzle!</div>
          <button className="dialog-button" onClick={ onClose }>Next Puzzle</button>
        </div>
      ) : (
        <div className="dialog failure">
          <div className="dialog-icon">😞</div>
          <div className="dialog-message">{`Oops! Better luck next time\n ${theCorrectSolution}`}</div>
          <button className="dialog-button" onClick={onClose}>Next Puzzle</button>
        </div>
      )}
    </div>
  );
};

export default SuccessDialog;
